<template>
  <div>
    <lcontainer class="mb-4">
      <div class="heading flex flex-row items-center justify-between py-2 px-8">
        <div>
          <div class="page text-white mb-4">
            {{ courses[0] ? courses[0].program : "No courses in this program" }}
          </div>
        </div>
        <div>
          <img :src="require('../../../assets/tenant_image.png')" alt="" />
        </div>
      </div>
    </lcontainer>
    <lcontainer>
      <lCrumbs class="py-4 px-6" :breadcrumb="breadcrumbItems" />
      <div class="flex justify-between">
        <page-header class="py-2 tenant-main-color">Courses</page-header>
        <div class="flex m-2"></div>
      </div>
      <hr class="mx-4" />
      <div class="mx-8 mt-4">
        <linput
          v-model="search"
          class="py-2"
          placeholder="Search by Course Name"
        />
      </div>
      <div />
      <div class="flex flex-wrap">
        <div v-for="course in courses" :key="course.id" class="w-full md:w-1/3">
          <course-card :course="course" class="flex m-4" />
        </div>
      </div>
    </lcontainer>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  components: {
    CourseCard: () => import("@/components/tenant/course-card"),
    ProgramCard: () => import("@/components/tenant/program-card"),
    LmsButton: () => import("@/components/general/button"),
    lcontainer: () => import("@/components/general/container"),
    LmsTable: () => import("@/components/admin/admin-table"),
    PageHeader: () => import("@/components/general/pageheader"),
    LmsSelect: () => import("@/components/forms/select"),
    linput: () => import("@/components/general/input"),
    lCrumbs: () => import("@/components/general/breadcrumbs.vue"),
  },
  data() {
    return {
      form: {},
      error: {},
      breadcrumbItems: [
        {
          disabled: true,
          to: "/tenant/programs",
          text: "All Programs",
        },
        {
          disabled: true,
          to: "#",
          text: " Courses",
        },
      ],
      search: "",
      courses: [],
      sort: [
        { text: "Name", value: "Name" },
        { text: "Email", value: "Email" },
      ],
      filter: [
        { text: "Tenants assigned to me", value: "Tenants assigned to me" },
        { text: "All Tenants", value: "All Tenants" },
      ],
    };
  },
  methods: {
    ...mapActions(["fetchCoursesInProgram"]),
    ...mapMutations(["updateLoader"]),
  },
  computed: {
    ...mapGetters(["getTenantPrograms"]),
  },
  async mounted() {
    this.updateLoader(true);
    this.courses = await this.fetchCoursesInProgram({
      id: this.$route.params.id,
    });
    this.updateLoader(false);
  },
};
</script>
<style scoped></style>
